var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { x } from '@xstyled/styled-components';
import { Cell } from './Table';
import { useAddFilter } from '../hooks/useAddFilter';
import { createFilterType, getStickyCollClassNames } from '../utils';
import { getCellSizeProps, getGroupClassNames } from '../utils';
import OverlayComponent from './FilterDropdown';
var ColumnFilterCell = function (_a) {
    var onChange = _a.onChange, value = _a.value, displayColumnWidth = _a.displayColumnWidth, filters = _a.filters, columnDefinition = _a.column, group = _a.group, comparators = _a.comparators;
    var cellSizeProps = getCellSizeProps(columnDefinition, displayColumnWidth);
    var handleAddFilter = useAddFilter(onChange);
    var handleChange = React.useCallback(function (event) {
        handleAddFilter((event === null || event === void 0 ? void 0 : event.target) ? event.target.value : event, columnDefinition);
    }, [handleAddFilter, columnDefinition]);
    var cellClassName = "cell".concat(getStickyCollClassNames(!!columnDefinition.sticky, columnDefinition.stickTo), " ").concat(getGroupClassNames(group));
    if (!columnDefinition.filtering) {
        return _jsx(Cell, __assign({ className: cellClassName }, cellSizeProps));
    }
    var filterType = createFilterType(columnDefinition);
    var filterConfig = filters === null || filters === void 0 ? void 0 : filters[filterType];
    var defaultComparators = comparators === null || comparators === void 0 ? void 0 : comparators[filterType];
    var RenderComponent = filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.CellComponent;
    if (!RenderComponent) {
        console.error("ERROR, using unknown filter type ".concat(filterType));
        return (_jsx(x.div, { children: _jsx("span", { children: "".concat(filterType, " filter") }) }));
    }
    return (_jsx(Cell, __assign({ className: cellClassName }, cellSizeProps, { children: _jsx(x.div, { children: _jsx(RenderComponent, __assign({ "data-test": columnDefinition.name, name: columnDefinition.name, onChange: handleChange, value: value, OverlayComponent: OverlayComponent, comparators: defaultComparators }, filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.defaultExtraProps, columnDefinition.filterExtraProps, (filterType == 'options' && { options: columnDefinition.filterOptions }))) }) })));
};
export default ColumnFilterCell;
